<template>
  <div class="customer">
    <el-select
      class="customer-select"
      filterable
      remote
      v-model="cuotomer"
      placeholder="请选择客户信息"
      value-key="user_cardno"
      :remote-method="remoteMethod"
      :loading="loading"
      @change="selectChange"
      style="width: 400px;max-width: 100%;"
      ref="select"
      @hook:mounted="cancalReadOnly"
      @visible-change="cancalReadOnly"
    >
      <el-option
        class="customer-select-option"
        v-for="(option, index) in optionList"
        :key="index"
        :label="option.user_name"
        :value="option"
        :value-key="option.user_cardno"
      >
        <div class="customer-select-item">
          <div>
            <span>{{ option.user_name }}</span>
            <span>{{ option.user_cardno }}</span>
          </div>
          <div>
            <span>{{ option.identification_number2 }}</span>
            <span>{{ option.user_mobile2 }}</span>
          </div>
          <template v-if="option.scrm_account_id">
            <div>
              <span>渠道</span>
            </div>
            <div>
              <span>{{ option.scrm_account_name }}</span>
              <span>{{ option.scrm_important_level }}</span>
            </div>
            <div>
              <span>{{ option.scrm_user_name }}</span>
            </div>
          </template>
          <div>
            <span>服务管家:{{ option.service_butler }}</span>
          </div>
          <div>
            <span>家庭医生:{{ option.family_doctor }}</span>
          </div>

        </div>
        <!-- <span>{{ option.user_sex_displayname }}</span> -->
      </el-option>
    </el-select>
    <!-- <div
      v-if="Object.keys(cuotomer).length > 0"
      class="customer-info"
    >
      <div class="van-cell van-cell--center van-cell--borderless van-contact-card van-contact-card--edit"><i class="van-icon van-icon-contact van-cell__left-icon">
        </i>
        <div class="van-cell__value van-cell__value--alone van-contact-card__value">
          <div>病案号：{{ cuotomer.user_cardno }}</div>
          <div>电话：{{ cuotomer.user_mobile }}</div>
          <div>性别：{{ cuotomer.user_sex_displayname }}</div>
          <div>证件类型：{{ hisPatientEnums.lst_document_type_map[String(cuotomer.document_type)] }}</div>
          <div>证件号：{{ cuotomer.identification_number }}</div>
          <div>生日：{{ cuotomer.user_birthday }}</div>
          <div>等级：{{ hisPatientEnums.lst_member_grade_map[String(cuotomer.user_level)] }}</div>
        </div>
      </div>
    </div> -->
    <span
      class="question-title-cion"
      @click="addCoustomer"
    >
      <!-- <i class="el-icon-plus"></i> -->
      <el-button
        size="mini"
        type="primary"
        icon="el-icon-circle-plus-outline"
      >添加客户</el-button>
    </span>
    <el-dialog
      :title="isEdit ? '编辑客户' : '新增客户'"
      top="20px"
      :visible.sync="dialogFormVisible"
      :destroy-on-close="false"
      :close-on-click-modal="false"
      width="95%"
      class="add-customer-dialog"
    >
      <el-form
        :model="cuotomerForm"
        :rules="cuotomerFormRules"
        size="mini"
        ref="cuotomerForm"
      >

        <el-form-item
          label="姓名"
          prop="user_name"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="cuotomerForm.user_name"
            autocomplete="off"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="推荐渠道"
          :label-width="formLabelWidth"
          prop="scrm_account_id"
        >
          <channel
            ref="channel"
            @answerChange="channelChange"
          />
          <!-- <span class="cuotomer-level-trip">
            必填，如果无渠道，请选择"散客"
          </span> -->
        </el-form-item>
        <el-form-item
          label="证件类型"
          prop="user_idtype"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="cuotomerForm.user_idtype"
            placeholder="请选择"
            @change="cuotomerIdNumber"
            :disabled="isEdit"
          >
            <el-option
              v-for="item in hisPatientEnums.lst_document_type"
              :key="item.Value"
              :label="item.Text"
              :value="item.Value"
            >
              <!-- {{ item.Text }} -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="证件号"
          prop="user_idnumber"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="cuotomerForm.user_idnumber"
            @blur="cuotomerIdNumber"
            autocomplete="off"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话"
          :label-width="formLabelWidth"
          prop="user_mobile"
        >
          <el-input
            v-model="cuotomerForm.user_mobile"
            autocomplete="off"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="性别"
          prop="user_sex"
          :label-width="formLabelWidth"
        >
          <el-radio-group
            v-model="cuotomerForm.user_sex"
            :disabled="isEdit"
          >
            <el-radio
              v-for="item in hisPatientEnums.lst_sex"
              :key="item.Value"
              :label="item.Value"
              :value="item.Value"
            >{{ item.Text }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="出生日期"
          :label-width="formLabelWidth"
          prop="user_birthday"
        >
          <el-date-picker
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            v-model="cuotomerForm.user_birthday"
            :picker-options="{
                disabledDate,
              }"
            style="width: 100%;"
            :disabled="isEdit"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="会员等级"
          :label-width="formLabelWidth"
          prop="user_level"
          class="cuotomer-level"
        >
          <el-select
            v-model="cuotomerForm.user_level"
            placeholder="请选择"
            :disabled="isEdit"
          >
            <el-option
              v-for="item in hisPatientEnums.lst_member_grade"
              :key="item.Value"
              :label="item.Text"
              :value="item.Value"
            >
              <!-- {{ item.Text }} -->
            </el-option>
          </el-select>
          <!-- <span class="cuotomer-level-trip">
            B、A等级为VIP接待标准请谨慎选择
          </span> -->
        </el-form-item>
        <el-form-item
          label="所属地区"
          :label-width="formLabelWidth"
          prop="customer_region_name"
          class="cuotomer-level"
        >
          <el-select
            v-model="cuotomerForm.customer_region_name"
            placeholder="请选择"
            filterable
            @change="onRegionChange"
            class="region-select"
            ref="regionSelect"
            @hook:mounted="cancalReadOnly"
            @visible-change="cancalReadOnly"
          >
            <el-option
              v-for="item in hisPatientEnums.lst_customer_region_type"
              :key="item.Value"
              :label="item.Text"
              :value="item.Text"
            >
              <!-- {{ item.Text }} -->
            </el-option>
          </el-select>
          <!-- <span class="cuotomer-level-trip">
            B、A等级为VIP接待标准请谨慎选择
          </span> -->
        </el-form-item>

        <el-form-item
          label="联系地址"
          :label-width="formLabelWidth"
          prop="user_address"
        >
          <el-input
            v-model="cuotomerForm.user_address"
            autocomplete="off"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>

      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="dialogFormVisible = false"
          size="mini"
        >取 消</el-button>
        <el-button
          type="primary"
          size="mini"
          :loading="btnLoading"
          @click="isEdit ? hisPatientEdit() : hisPatientAdd()"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixins from "./mixins";
import cuotomerService from "@/apis/customer/index.js";
import { getHisPatientEnums } from "@/models/customer";
import { Message } from "element-ui";
import idCardTool from "@/utils/idCard.js";
import moment from "moment";
import channel from "./channel.vue";

const initForm = {
  user_level: 20584827,
};
const idCardType = "1";

export default {
  name: "customer",
  mixins: [mixins],
  components: {
    channel,
  },
  data() {
    return {
      btnLoading: false,
      dialogFormVisible: false,
      formLabelWidth: "80px",
      isEdit: false,
      cuotomerForm: {
        ...initForm,
      },
      cuotomerFormRules: {
        user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        user_mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
              if (!reg.test(value)) {
                callback(new Error("请输入正确的联系电话"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        user_birthday: [
          { required: true, message: "请输入出生日期", trigger: "change" },
        ],
        user_sex: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
        user_idtype: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        user_idnumber: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const { cuotomerForm } = this;
              console.log(value);
              console.log(cuotomerForm);
              if (
                cuotomerForm.user_idtype == idCardType &&
                !idCardTool.checkIdCardNo(value)
              ) {
                callback(new Error("请输入正确的身份证号"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        user_level: [
          { required: true, message: "请选择会员等级", trigger: "change" },
        ],
        scrm_account_id: [
          { required: true, message: "请选择推荐渠道", trigger: "change" },
        ],
        customer_region_name: [
          { required: true, message: "请选择所属地区", trigger: "change" },
        ],
      },

      query_text: "",
      cuotomer: {},
      optionList: [],
      loading: false,
      hisPatientEnums: {},
      lastIndex: 1,
    };
  },
  created() {
    this.getHisPatientEnums();
  },
  mounted() {
    // this.selectHanlder();
  },
  methods: {
    channelChange(value) {
      const { answer } = value;
      this.cuotomerForm = {
        ...this.cuotomerForm,
        scrm_account_id: answer.account_id,
        scrm_account_name: answer.account_name,
        scrm_user_id: answer.user_id,
        scrm_user_name: answer.user_name,
        scrm_important_level: answer.important_level,
      };
      console.log(value);
    },
    selectChange(value) {
      if (!value.scrm_account_id || !value.customer_region_code) {
        Message({
          message: "请完善客户信息后才能选用",
          type: "warning",
        });
        this.editCustomerInfo(value);
        this.cuotomer = {};
        return;
      }
      this.$store.dispatch("customer/setCustomerInfo", value);
      this.change(value, "customer");
    },
    disabledDate(currentDate) {
      return moment(currentDate).isAfter(moment(), "date");
    },
    editCustomerInfo(customer) {
      this.isEdit = true;
      this.cuotomerForm = {
        ...customer,
        user_idtype: `${customer.document_type}`,
        user_idnumber: customer.identification_number,
        user_mobile: customer.user_mobile,
        user_sex: customer.user_sex,
        user_birthday: customer.user_birthday,
        user_level: customer.user_level,
        scrm_account_id: customer.scrm_account_id || "",
        scrm_account_name: customer.scrm_account_name || "",
        customer_region_code: customer.customer_region_code || "",
        customer_region_name: customer.customer_region_name || "",
      };
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs.channel) {
          this.$refs.channel.setInitialValue({
            account_id: customer.scrm_account_id,
            account_name: customer.scrm_account_name,
            user_id: customer.scrm_user_id,
            user_name: customer.scrm_user_name,
            important_level: customer.scrm_important_level,
            showName: `${customer.scrm_account_name}(${customer.scrm_user_name})`,
          });
        }
      });
    },
    addCoustomer() {
      this.isEdit = false;
      this.$refs.cuotomerForm && this.$refs.cuotomerForm.resetFields();
      this.cuotomerForm = {
        ...initForm,
      };
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs.channel) {
          this.$refs.channel.reset();
        }
      });
    },
    async hisPatientAdd() {
      if (this.btnLoading) return;
      let isPass = true;
      try {
        await this.$refs.cuotomerForm.validate();
      } catch (err) {
        isPass = err;
      }
      if (!isPass) return;
      const params = this.cuotomerForm;
      this.btnLoading = true;
      cuotomerService
        .hisPatientAdd({
          ...params,
          channel_id: params.scrm_account_id,
          channel_name: params.scrm_account_name,
        })
        .then((res) => {
          console.log(res);
          if (res.Status == -1) {
            Message({
              message: res.Message || "添加失败",
              type: "error",
            });
          } else {
            this.optionList = [res];
            this.$nextTick(() => {
              this.cuotomer = res;
            });
            this.selectChange(res, "customer");
            this.dialogFormVisible = false;
            Message({
              message: "添加成功",
              type: "success",
            });
          }

          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
    cuotomerIdNumber() {
      const { cuotomerForm } = this;
      const value = cuotomerForm.user_idnumber;
      if (idCardTool.checkIdCardNo(value) && cuotomerForm.user_idtype == "1") {
        const cardInfo = idCardTool.getIdCardInfo(value);
        console.log(idCardTool);
        cuotomerForm.user_birthday = cardInfo.birthday;
        cuotomerForm.user_sex = cardInfo.gender === "男" ? 1 : 2;
        this.cuotomerForm = {
          ...cuotomerForm,
        };
        this.$refs.cuotomerForm.$forceUpdate();
      }
    },
    getHisPatientEnums() {
      getHisPatientEnums().then((res) => {
        console.log(res);
        this.hisPatientEnums = res;
      });
    },
    onRegionChange(value) {
      const lst_customer_region_type =
        this.hisPatientEnums.lst_customer_region_type;
      lst_customer_region_type.some((item) => {
        if (item.Text === value) {
          this.cuotomerForm.customer_region_code = item.Value;
          return true;
        }
      });
      console.log(value);
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select, regionSelect } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          const regionInput =
            regionSelect.$el.querySelector(".el-input__inner");
          regionInput.removeAttribute("readonly");
        }
      });
    },
    selectHanlder() {
      document.querySelectorAll(".el-select").forEach((item) => {
        item.children[0].children[0].removeAttribute("readOnly");
        item.children[0].children[0].onblur = function () {
          let _this = this;
          setTimeout(() => {
            _this.removeAttribute("readOnly");
          }, 300);
        };
      });
    },
    remoteMethod(query) {
      console.log("搜索字段", query);
      if (!query) return;

      this.loading = true;

      this.lastIndex = this.lastIndex + 1;
      const lastIndex = this.lastIndex;
      const params = {
        query_text: query,
      };
      cuotomerService.hisPatientSearch(params).then((res) => {
        if (this.lastIndex === lastIndex) {
          if (res.length > 500) {
            this.optionList = res.slice(0, 500);
          } else {
            this.optionList = res;
          }
          this.loading = false;
        }
      });
    },
    async hisPatientEdit() {
      if (this.btnLoading) return;
      let isPass = true;
      try {
        await this.$refs.cuotomerForm.validate();
      } catch (err) {
        isPass = err;
      }
      if (!isPass) return;

      const params = {
        patientID: this.cuotomerForm.patientId,
        scrm_account_id: this.cuotomerForm.scrm_account_id,
        scrm_account_name: this.cuotomerForm.scrm_account_name,
        channel_id: this.cuotomerForm.scrm_account_id,
        channel_name: this.cuotomerForm.scrm_account_name,
        customer_region_code: this.cuotomerForm.customer_region_code,
        customer_region_name: this.cuotomerForm.customer_region_name,
      };

      this.btnLoading = true;
      cuotomerService
        .hisPatientEdit(params)
        .then((res) => {
          this.optionList = [res];
          this.$nextTick(() => {
            this.cuotomer = res;
          });
          this.selectChange(res, "customer");
          this.dialogFormVisible = false;
          Message({
            message: "编辑成功",
            type: "success",
          });
          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.customer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.van-contact-card::before {
  height: 0;
}
.customer-select-option {
  // display: flex;
  justify-content: space-between;
  overflow: auto;
  height: unset;
  line-height: 20px;
  padding: 10px 20px;
  span {
    white-space: pre-line;
  }
}

.customer-select-item {
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    justify-content: space-between;
  }
}
.question-title-cion {
  cursor: pointer;
  font-size: 20px;
  margin-left: 10px;
}
</style>
<style lang="scss">
.customer-select {
  .el-select-dropdown__item {
  }
}
.cuotomer-level {
  .el-form-item__content {
    display: flex;
    flex-direction: column;
  }
}
.cuotomer-level-trip {
  color: red;
  font-size: 12px;
  line-height: 14px;
}
</style>

